const publicSrc_="www.g3wei.com"
const rowsSrc_="b.g3wei.com"
const img01Src_="http://img01.g3wei.com/"
const siteSrc_="www.g3wei.com/site/"

export default{
  publicSrc_,
  rowsSrc_,
  img01Src_,
  siteSrc_
}



// WEBPACK FOOTER //
// ./src/api/srcpublic.js